(function(){
  'use strict';
  var ROOT = document.querySelector('.evdm');
  if (!ROOT || ROOT.dataset.evdmInit==='1') return;
  ROOT.dataset.evdmInit = '1';

  var ov        = ROOT.querySelector('#evdm-overlay');
  var dr        = ROOT.querySelector('#evdm-drawer');
  var tabMenu   = ROOT.querySelector('#evdm-tab-menu');
  var panels    = ROOT.querySelectorAll('.evdm-panel');
  var mainPanel = ROOT.querySelector('.evdm-panel[data-panel="main"]');

  var stack = ['main'];

  function show(name){
    panels.forEach(function(p){
      var n = p.getAttribute('data-panel');
      if (n === name) p.classList.add('is-active');
      else p.classList.remove('is-active');
    });
    if (name === 'main') mainPanel.classList.remove('is-pushed');
    else mainPanel.classList.add('is-pushed');
  }
  function go(name){ stack.push(name); show(name); }
  function back(){ if (stack.length > 1) { stack.pop(); show(stack[stack.length-1]); } }
  function reset(){ stack = ['main']; show('main'); }

  function open(){
    ROOT.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function shut(){
    ROOT.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(reset, 320);
  }
  function toggle(){ ROOT.classList.contains('is-open') ? shut() : open(); }

  /* Triggers */
  ov.addEventListener('click', shut);
  if (tabMenu) tabMenu.addEventListener('click', function(e){ e.preventDefault(); toggle(); });
  ROOT.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click', shut); });
  var topClose = ROOT.querySelector('#evdm-close');
  if (topClose) topClose.addEventListener('click', shut);
  ROOT.querySelectorAll('[data-back]').forEach(function(b){ b.addEventListener('click', back); });
  ROOT.querySelectorAll('[data-go]').forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); go(b.getAttribute('data-go')); });
  });

  /* Close on link click (navigations) */
  ROOT.querySelectorAll('.evdm-drawer a[href]').forEach(function(a){
    a.addEventListener('click', function(){ setTimeout(shut, 80); });
  });

  /* Escape closes / back if in sub-panel */
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && ROOT.classList.contains('is-open')){
      if (stack.length > 1) back(); else shut();
    }
  });

  /* Swipe-left closes (only from main panel) */
  var startX = null;
  if (dr){
    dr.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
    dr.addEventListener('touchend', function(e){
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (dx < -60 && stack[stack.length-1] === 'main') shut();
      if (dx > 60 && stack.length > 1) back(); // swipe right = back
      startX = null;
    }, {passive:true});
  }

  /* Hijack existing Horizon hamburger */
  var SEL = ['.header__menu-drawer-toggle','.header__icon--menu','.header__menu-toggle',
    'menu-drawer button[aria-controls]','menu-drawer-toggle','button[aria-controls="menu-drawer"]',
    'button[aria-controls*="menu" i]','button[aria-label*="menu" i]:not(.evdm-tab):not(.evdm-close)',
    'header-component button.header__icon:first-of-type','.header-component__menu-toggle','a[href="#menu"]'];
  function hijack(el){
    if (!el || el.dataset.evdmHijack === '1') return;
    if (el.closest('.evdm')) return;
    el.dataset.evdmHijack = '1';
    el.addEventListener('click', function(e){ e.preventDefault(); e.stopImmediatePropagation(); toggle(); }, true);
  }
  function scan(){ SEL.forEach(function(s){ try{ document.querySelectorAll(s).forEach(hijack); }catch(_){}}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver){
    new MutationObserver(function(m){ for(var i=0;i<m.length;i++){ if(m[i].addedNodes&&m[i].addedNodes.length){ scan(); break; } } }).observe(document.body, {childList:true, subtree:true});
  }
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t=setTimeout(scan,200); });

  /* Highlight current page in tabs */
  var path = location.pathname;
  ROOT.querySelectorAll('.evdm-tab').forEach(function(t){
    var href = t.getAttribute('href');
    if (!href) return;
    if (href === path || (href !== '/' && path.indexOf(href) === 0)) t.classList.add('is-current');
  });

  document.addEventListener('cart:updated', function(e){
    var count = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
    ROOT.querySelectorAll('.evdm-tab__badge').forEach(function(b){
      if (count > 0){ b.textContent = count; b.style.display = ''; } else b.style.display = 'none';
    });
  });
})();
